import { useApi } from '@/api';
import { TableSkeleton } from '@/components';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';
import {
  EtherScanPictogram,
  Flex,
  useTableProps,
  DataTable,
  RelativeDateTime,
  PercentageValue,
  Box,
  ArrowRightIcon
} from '@blockanalitica/ui';

export default function EventsTable({ ilk }) {
  const { pagination, sorting } = useTableProps({
    pageSize: 10,
    initialSorting: '-order_index',
    filtersDebounceTime: 50
  });
  const [data, error] = useApi({
    url: `/groups/core/ilks/${ilk}/parameters/stability-fee/events/`,
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    const columns: TableColumn[] = [
      {
        header: 'Stability Fee Parameter',
        getCell: (row) => row.stability_fee,
        cellAlign: 'flex-start',
        headerAlign: 'flex-start'
      },
      {
        header: 'Value change',
        getCell: (row) => (
          <Flex
            flexDirection="row"
            gap="2xs"
            alignContent="center"
            alignItems="center">
            <PercentageValue value={row.previous_value} />

            <Box color="muted">
              <ArrowRightIcon size="1" />
            </Box>
            <PercentageValue value={row.current_value} />
          </Flex>
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'current_value'
      },
      {
        header: 'Time',
        getCell: (row) => (
          <Flex gap={['xs', '3xs']} color="muted">
            <RelativeDateTime value={row.datetime} />
            <a
              href={`https://etherscan.io/tx/${row.tx_hash}`}
              target="_blank"
              rel="noreferrer">
              <EtherScanPictogram size="0" />
            </a>
          </Flex>
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'order_index'
      }
    ];

    return (
      <>
        <DataTable
          rows={data['results']}
          columns={columns}
          getKey={(row) => row.order_index}
          sorting={sorting}
          pagination={{
            ...pagination,
            totalRecords: data.count
          }}
        />
      </>
    );
  }
  return <TableSkeleton />;
}
